<div class="container">
  <div class="wrap">
    <ng-container *ngIf="isAvailable || !editable">
      <div class="integrations-skeleton" *ngIf="loading; else integrationsContent">
        <div class="integrations-skeleton__title">
          <h3>{{ 'pages.restaurantAccount.integrations' | translate }}</h3>
          <ngx-skeleton-loader *ngIf="isAvailable && editable" animation="progress"></ngx-skeleton-loader>
        </div>
        <div class="integrations-skeleton__row" *ngFor="let i of [].constructor(3)">
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress"></ngx-skeleton-loader>
        </div>
      </div>

      <ng-template #integrationsContent>
        <app-restaurant-integrations
          [integrations]="integrations"
          [editable]="editable"
          [isAvailable]="isAvailable"
          (add)="addIntegration()"
          (edit)="editIntegration($event)"
        ></app-restaurant-integrations>
      </ng-template>
    </ng-container>
  </div>
</div>
